import { render } from "./MintCoverImage.vue?vue&type=template&id=5085614f&scoped=true"
import script from "./MintCoverImage.vue?vue&type=script&lang=js"
export * from "./MintCoverImage.vue?vue&type=script&lang=js"

import "@/Common/Styles/fileInput.scss?vue&type=style&index=0&id=5085614f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5085614f"]])

export default __exports__